import {
  APPLICATION_STATUS_BASE_DATA,
  APPLICATION_STATUS_CASE_DETAILS,
  APPLICATION_STATUS_CONTRACT_PARTNER,
  APPLICATION_STATUS_DESCRIPTION,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_SUMMARY,
} from "./applicationStatus";
import { FormSteps } from "../../types/FormServiceBase";
import HintBox from "../../components/Box/HintBox/HintBox";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import React from "react";
import EmploymentContractBase from "../../components/Form/EmploymentContract/EmploymentContractBase";
import Insurance from "../../components/Form/Common/Insurance/Insurance";
import SummaryHintBox from "../../components/Form/Common/SummaryHintBox";
import { Navigate } from "react-router";
import { getCaseLink } from "../productService";
import EmploymentContractDescription from "../../components/Form/EmploymentContract/EmploymentContractDescription";
import EmploymentContractDetails from "../../components/Form/EmploymentContract/EmploymentContractDetails";
import EmploymentContractOpposingParty from "../../components/Form/EmploymentContract/EmploymentContractOpposingParty";
import EmploymentContractSummary from "../../components/Form/EmploymentContract/EmploymentContractSummary";
import PowerOfAttorneyIntroHintBox from "../../components/Form/LitigationCase/PowerOfAttorneyIntroHintBox";
import PowerOfAttorney from "../../components/Form/LitigationCase/PowerOfAttorney";
import { DocumentsForm } from "../../components/Form/DocumentsForm/DocumentsForm";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_BASE_DATA]: {
    title: "Antrag - Ihr Arbeitsvertrag | Legalbird",
    applicationStatus: APPLICATION_STATUS_BASE_DATA,
    stepUrl: "vertrag",
    render: (props) => (
      <>
        <HintBox headline={"Wir kümmern uns um Ihre Vertragsangelegenheit!"}>
          <p>
            Schildern Sie uns bitte kurz Ihr arbeitsrechtliches Anliegen anhand der folgenden Fragen. Halten Sie relevante Dokumente wie Ihren Arbeitsvertrag,
            Abmahnungen oder Gehaltsabrechnungen bereit, falls möglich. Jede Information hilft uns dabei, Sie bestmöglich zu beraten und direkt die passenden
            rechtlichen Schritte einzuleiten. Sollten Sie bei einer Frage unsicher sein, machen Sie sich keine Sorgen: Sie haben zusätzlich die Möglichkeit,
            Ihren Fall frei aus Ihrer Sicht zu schildern.
          </p>
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={15} />
        <EmploymentContractBase {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CASE_DETAILS]: {
    title: "Antrag - Ihr Arbeitsverhältnis | Legalbird",
    applicationStatus: APPLICATION_STATUS_CASE_DETAILS,
    stepUrl: "vertragsdetails",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={20} />
        <EmploymentContractDetails {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_PARTNER]: {
    title: "Antrag - Angaben zu Ihrem Arbeitgeber | Legalbird",
    applicationStatus: APPLICATION_STATUS_CONTRACT_PARTNER,
    stepUrl: "arbeitgeber",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={25} />
        <EmploymentContractOpposingParty {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DESCRIPTION]: {
    title: "Antrag - Beschreibung | Legalbird",
    applicationStatus: APPLICATION_STATUS_DESCRIPTION,
    stepUrl: "beschreibung",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={35} />
        <EmploymentContractDescription {...props} applicationStatus={APPLICATION_STATUS_DESCRIPTION} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Dokumente | Legalbird",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    stepUrl: "unterlagen",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={47} />
        <DocumentsForm product={props.product} submitProps={props.submitProps} />
      </>
    ),
  },
  [APPLICATION_STATUS_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    applicationStatus: APPLICATION_STATUS_INSURANCE,
    stepUrl: "versicherung",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"insurance"} progress={80} />
        <Insurance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: {
    title: "Antrag - Überprüfen | Legalbird",
    applicationStatus: APPLICATION_STATUS_SUMMARY,
    stepUrl: "ueberpruefen",
    render: (props) => (
      <>
        <SummaryHintBox />
        <EmploymentContractSummary {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: {
    title: "Antrag - Vollmacht | Legalbird",
    applicationStatus: APPLICATION_STATUS_POWER_OF_ATTORNEY,
    stepUrl: "vollmacht",
    render: (props) => (
      <>
        <PowerOfAttorneyIntroHintBox {...props} />
        <PowerOfAttorney {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DONE]: {
    title: "Mein Fall | Legalbird",
    applicationStatus: APPLICATION_STATUS_DONE,
    stepUrl: "abgeschlossen",
    render: ({ product }) => <Navigate to={getCaseLink(product)} />,
  },
};

export default formSteps;
